import React from 'react';
import { GraduationCap, Users, Shield, Home } from 'lucide-react';

const iconMap = {
  GraduationCap,
  Users,
  Shield,
  Home
};

const PrioritiesSection = ({ data }) => {
  const priorities = data?.priorities || [];
  
  return (
    <section id="priorities" className="py-20 lg:py-32 bg-campaign-navy text-white relative overflow-hidden">
      {/* Subtle Decorative Background Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-campaign-cyan/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-campaign-red/5 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-6 lg:px-20 relative z-10">
        {/* Clear Header with Good Spacing */}
        <div className="text-center mb-16 lg:mb-24">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold mb-8 leading-[1.1] uppercase tracking-tight">
            What We're<br className="hidden sm:block" /> Fighting For
          </h2>
          <p className="text-xl lg:text-2xl xl:text-3xl text-white/90 max-w-4xl mx-auto leading-relaxed">
            Real solutions for the challenges facing Rochester families, students, and neighborhoods
          </p>
        </div>
        
        {/* Priority Cards - Better Spacing */}
        <div className="grid md:grid-cols-2 gap-8 lg:gap-10 max-w-6xl mx-auto">
          {priorities.map((priority) => {
            const IconComponent = iconMap[priority.icon];
            return (
              <div 
                key={priority.id}
                className="group bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden border border-white/20 hover:bg-white/15 transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl"
              >
                {/* Image - Consistent Height */}
                <div className="relative h-64 lg:h-72 overflow-hidden">
                  <img 
                    src={priority.image} 
                    alt={priority.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/95 via-slate-900/50 to-transparent"></div>
                  
                  {/* Icon and Title on Image - Better Positioning */}
                  <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-8">
                    <div className="flex items-center gap-4">
                      <div className="w-14 h-14 lg:w-16 lg:h-16 bg-campaign-red rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg">
                        <IconComponent className="h-7 w-7 lg:h-8 lg:w-8 text-white" />
                      </div>
                      <h3 className="text-xl lg:text-2xl xl:text-3xl font-bold text-white uppercase leading-tight">
                        {priority.title}
                      </h3>
                    </div>
                  </div>
                </div>
                
                {/* Description - Better Spacing */}
                <div className="p-6 lg:p-8">
                  <p className="text-base lg:text-lg xl:text-xl leading-relaxed text-white/90">
                    {priority.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export { PrioritiesSection };
